import {Input, Modal, ModalProps} from "antd";
import {useState} from "react";
import * as React from "react";

interface RemarkModalProps extends ModalProps{
    onComplete:Function
}

function RemarkModal(props: RemarkModalProps) {
    const [remark, setRemark] = useState<string>();

    const onOk = (e:React.MouseEvent<HTMLButtonElement>)=>{
        props.onComplete?.(remark)
        props.onOk?.(e)
    }

    return <Modal {...props} onOk={onOk}>
        <Input.TextArea value={remark} onChange={(e)=>setRemark(e.target.value)}/>
    </Modal>
}

export default RemarkModal;